"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var DuckWater = function DuckWater(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.248,18.88a2.5,2.5,0,0,1,3.825.511h0a2.111,2.111,0,0,0,1.486.874,2.8,2.8,0,0,0,1.889-1.016,2.5,2.5,0,0,1,4.287.389,1.279,1.279,0,0,0,1.051.627,1.863,1.863,0,0,0,1.476-.846A2.418,2.418,0,0,1,19.4,18.212a2.511,2.511,0,0,1,1.2.306,6.47,6.47,0,0,0,.867-3.891A8.525,8.525,0,0,0,19.209,9.3a8.634,8.634,0,0,1-.6-.765c-.912-1.368-.758-2.617-.336-2.8,1.168.907,2.942,2.1,4.158,2.1a1.341,1.341,0,0,0,.589-.121,1.3,1.3,0,0,0,.711-1.27c0-1.111-1.971-3.7-3.146-5.147a.8.8,0,0,0-.076-.078A3.392,3.392,0,0,0,17.983.2a4.377,4.377,0,0,0-3.859,1.87c-1.782,2.631-.607,5.911-.08,7.447a.5.5,0,0,1-.471.663l-5.594.02a12.75,12.75,0,0,1-2.671-.273c.247,1.3,1.145,4.273,4.171,4.273h3.5a.75.75,0,0,1,0,1.5h-3.5c-4.035,0-5.511-3.879-5.747-6.171a.521.521,0,0,1,0-.055c-.423-.153-.78-.307-1.078-.434A2.19,2.19,0,0,0,1.3,8.721C.385,8.942.234,10.6.226,11.566A10.015,10.015,0,0,0,3.248,18.88ZM17.979,2.073a1,1,0,1,1-1,1A1,1,0,0,1,17.979,2.073Z",
    fill: fill,
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,22.682a1.018,1.018,0,0,0-1.068-.929c-1.583.135-2.667-1.555-2.675-1.569a1.047,1.047,0,0,0-1.716.023,3.375,3.375,0,0,1-2.753,1.557,2.8,2.8,0,0,1-2.4-1.481,1.044,1.044,0,0,0-1.717-.157,4.3,4.3,0,0,1-3.105,1.638A3.554,3.554,0,0,1,5.8,20.184a1.042,1.042,0,0,0-1.638-.091c-.014.018-1.487,1.812-3.11,1.7A.979.979,0,0,0,0,22.742c-.01.187.042,1.057,1.168,1.057a5.833,5.833,0,0,0,3.726-1.607,5.242,5.242,0,0,0,3.664,1.572,5.858,5.858,0,0,0,3.811-1.5,4.576,4.576,0,0,0,3.416,1.5,5.153,5.153,0,0,0,3.622-1.5,4.78,4.78,0,0,0,3.661,1.483A1,1,0,0,0,24,22.682Z",
    fill: fill,
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0"
  })));
};
DuckWater.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
DuckWater.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = DuckWater;